<template>
  <div id="about">
            <router-link to="/">Home</router-link>
    <p>Through the <b>Teletraan Alpha Project</b> , 4/25th Paratroopers are receiving training in application development. </p>
        <h2>In development now, 4/25th Paratroopers will be able report round counts for weapons systems in real time, on and off-line (disconnected). These reports are rolled into a CSV file for leveraging of the mass load functions available.</h2> 
          <br/>
          <p>To be a part of this project or similar opportunities, please contact <u>graham@sparwerx.com</u></p> 
      <h3 style="text-align:center">Check Out These Links</h3>
    <ul style="text-align:center">
      <li>
        <a
          href="https://www.SPARwerx.com"
          target="_blank"
          rel="noopener"
        >The 4/25th Brigade Innovation Initiative</a>
      </li>
      <li>
        <a
          href="https://PMCSx.SPARwerx.com"
          target="_blank"
          rel="noopener"
        >PMCSx - Your new Digital 5988</a>
      </li>
       <li>
        <a
          href="https://Eats.SPARwerx.com"
          target="_blank"
          rel="noopener"
        >Spartan Eats - Your to-go plate ordering app</a>
      </li>
       <li>
        <a
          href="https://FASTT.SPARwerx.com"
          target="_blank"
          rel="noopener"
        >FASTT - The powerful project management tool for staff tasker tracking</a>
      </li>
    </ul>
    </div>
</template>

<script>
export default {
  name: 'About'
};
</script>

<style lang="scss" scoped>
#about {

}

.router-link {
  color: black
}
</style>